import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createdLabel: {
		id: 'created-date.read.created-label',
		defaultMessage: 'Created',
		description: 'Label for created field',
	},
});
